function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgScreenCast(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 22,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#screen-cast_svg__clip0_359:99)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M1.378 3.227v-.515c0-.476.178-.933.495-1.27A1.64 1.64 0 013.067.916h16.326c.447 0 .877.19 1.194.526.317.337.494.794.494 1.27v13.045c0 .476-.177.933-.494 1.27a1.64 1.64 0 01-1.194.526h-4.566",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M10.52 17.577a10.26 10.26 0 00-.694-3.722 9.787 9.787 0 00-1.981-3.157A9.127 9.127 0 004.878 8.59a8.67 8.67 0 00-3.5-.74M5.978 17.577c0-.643-.118-1.28-.349-1.873a4.924 4.924 0 00-.996-1.59 4.593 4.593 0 00-1.493-1.061 4.362 4.362 0 00-1.762-.373",
    stroke: props.color,
    strokeWidth: 1.943,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M1.378 18.685c.576 0 1.042-.496 1.042-1.108 0-.612-.466-1.107-1.042-1.107-.575 0-1.041.495-1.041 1.107s.466 1.108 1.041 1.108z",
    fill: props.color
  })), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "screen-cast_svg__clip0_359:99"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.color,
    transform: "translate(.337)",
    d: "M0 0h21.651v18.685H0z"
  }))));
}

export default SvgScreenCast;